import { useOptions } from '../../../../../../../../../../components/CIMSSelect/hooks/useOptions'
import {
  MetadataResponseDiscipline,
  Response,
} from '../../../RFITrackerContext'

type RespondedResponseDisciplineOptionsOptions = {
  rfiResponses: Response[]
  allResponseDisciplines: MetadataResponseDiscipline[]
}

export function useRespondedResponseDisciplineOptions({
  rfiResponses,
  allResponseDisciplines,
}: RespondedResponseDisciplineOptionsOptions) {
  const respondedIds = rfiResponses?.map(
    ({ responseDisciplineId }) => responseDisciplineId
  )
  return useOptions({
    items: allResponseDisciplines,
    value: 'id',
    label: 'name',
    sort: 'name',
    disabled: ({ id }) => respondedIds?.includes(id),
    tooltip: ({ id, description }) =>
      respondedIds?.includes(id)
        ? 'Discipline has already responded'
        : description,
  })
}
